[
  {
    "id": "cartodb-dark",
    "tileUrlTemplates": [
      "https://{s}.basemaps.cartocdn.com/dark_all/{z}/{x}/{y}.png",
      "https://basemaps.cartocdn.com/dark_all/{z}/{x}/{y}.png",
      "https://cartodb-basemaps-{s}.global.ssl.fastly.net/dark_all/{z}/{x}/{y}.png",
      "https://{s}.basemaps.cartocdn.com/dark_nolabels/{z}/{x}/{y}.png",
      "https://basemaps.cartocdn.com/dark_nolabels/{z}/{x}/{y}.png",
      "https://cartodb-basemaps-{s}.global.ssl.fastly.net/dark_nolabels/{z}/{x}/{y}.png"
    ],
    "lineWidthStops": { "0": 1.0, "2": 1.0, "3": 1.0, "10": 2.0, "12": 2.0 },
    "lineStyles": [
      { "color": "rgb(40, 40, 40)", "layerSuffix": "ne", "endZoom": 4 },
      { "color": "rgb(40, 40, 40)", "layerSuffix": "ne-disp", "endZoom": 4 },
      { "color": "rgb(40, 40, 40)", "layerSuffix": "osm", "startZoom": 5 },
      { "color": "rgb(40, 40, 40)", "layerSuffix": "osm-disp", "startZoom": 5 },
      { "color": "rgb(40, 40, 40)", "layerSuffix": "osm-internal", "startZoom": 5, "widthFraction": 0.3, "dashArray": [2, 2], "delWidthFactor": 2.0 },
      { "color": "rgb(40, 40, 40)", "layerSuffix": "ne-internal", "startZoom": 4, "endZoom": 4, "widthFraction": 0.3, "dashArray": [2, 2], "delWidthFactor": 3.0 }
    ]
  },
  {
    "id": "cartodb-dark-retina",
    "tileUrlTemplates": [
      "https://{s}.basemaps.cartocdn.com/dark_all/{z}/{x}/{y}{r}.png",
      "https://basemaps.cartocdn.com/dark_all/{z}/{x}/{y}{r}.png",
      "https://cartodb-basemaps-{s}.global.ssl.fastly.net/dark_all/{z}/{x}/{y}{r}.png",
      "https://{s}.basemaps.cartocdn.com/dark_nolabels/{z}/{x}/{y}{r}.png",
      "https://basemaps.cartocdn.com/dark_nolabels/{z}/{x}/{y}{r}.png",
      "https://cartodb-basemaps-{s}.global.ssl.fastly.net/dark_nolabels/{z}/{x}/{y}{r}.png"
    ],
    "lineWidthStops": { "0": 1.5, "2": 1.5, "3": 1.5, "6": 2.5, "10": 3.0 },
    "lineStyles": [
      { "color": "rgb(40, 40, 40)", "layerSuffix": "ne", "endZoom": 4 },
      { "color": "rgb(40, 40, 40)", "layerSuffix": "ne-disp", "endZoom": 4 },
      { "color": "rgb(40, 40, 40)", "layerSuffix": "osm", "startZoom": 5 },
      { "color": "rgb(40, 40, 40)", "layerSuffix": "osm-disp", "startZoom": 5 },
      { "color": "rgb(40, 40, 40)", "layerSuffix": "osm-internal", "startZoom": 5, "widthFraction": 0.3, "dashArray": [4, 4], "delWidthFactor": 2.0 },
      { "color": "rgb(40, 40, 40)", "layerSuffix": "ne-internal", "startZoom": 4, "endZoom": 4, "widthFraction": 0.3, "dashArray": [4, 4], "delWidthFactor": 3.0 }
    ]
  },
  {
    "id": "cartodb-light",
    "tileUrlTemplates": [
      "https://{s}.basemaps.cartocdn.com/light_all/{z}/{x}/{y}.png",
      "https://basemaps.cartocdn.com/light_all/{z}/{x}/{y}.png",
      "https://cartodb-basemaps-{s}.global.ssl.fastly.net/light_all/{z}/{x}/{y}.png",
      "https://{s}.basemaps.cartocdn.com/light_nolabels/{z}/{x}/{y}.png",
      "https://basemaps.cartocdn.com/light_nolabels/{z}/{x}/{y}.png",
      "https://cartodb-basemaps-{s}.global.ssl.fastly.net/light_nolabels/{z}/{x}/{y}.png",
      "https://{s}.basemaps.cartocdn.com/rastertiles/voyager/{z}/{x}/{y}.png",
      "https://basemaps.cartocdn.com/rastertiles/voyager/{z}/{x}/{y}.png",
      "https://{s}.basemaps.cartocdn.com/rastertiles/voyager_nolabels/{z}/{x}/{y}.png",
      "https://basemaps.cartocdn.com/rastertiles/voyager_nolabels/{z}/{x}/{y}.png",
      "https://{s}.basemaps.cartocdn.com/rastertiles/voyager_labels_under/{z}/{x}/{y}.png",
      "https://basemaps.cartocdn.com/rastertiles/voyager_labels_under/{z}/{x}/{y}.png"
    ],
    "lineWidthStops": { "1": 0.5, "2": 0.75, "3": 0.75, "4": 1.0, "5": 1.0, "7": 1.75, "16": 2.5 },
    "lineStyles": [
      { "color": "rgb(235, 214, 214)", "layerSuffix": "ne", "endZoom": 4, "lineExtensionFactor": 0.1, "delWidthFactor": 2.5 },
      { "color": "rgb(235, 214, 214)", "layerSuffix": "ne-disp", "endZoom": 4, "delWidthFactor": 0 },
      { "color": "rgb(235, 214, 214)", "layerSuffix": "osm", "alpha": 0.1,  "startZoom": 6,  "lineWidthStops": { "6": 9, "10": 8, "14": 8 }, "lineExtensionFactor": 0.1 },
      { "color": "rgb(235, 214, 214)", "layerSuffix": "osm", "startZoom": 5, "lineExtensionFactor": 0.1 },
      { "color": "rgb(235, 214, 214)", "layerSuffix": "osm-disp", "startZoom": 5,  "delWidthFactor": 0 },
      { "color": "rgb(235, 214, 214)", "layerSuffix": "osm-internal", "startZoom": 5, "widthFraction": 0.5, "dashArray": [2, 2], "delWidthFactor": 2.0 },
      { "color": "rgb(235, 214, 214)", "layerSuffix": "ne-internal", "startZoom": 4, "endZoom": 4, "widthFraction": 0.5, "dashArray": [2, 2], "delWidthFactor": 2.5 }
    ]
  },
  {
    "id": "cartodb-light-retina",
    "tileUrlTemplates": [
      "https://{s}.basemaps.cartocdn.com/light_all/{z}/{x}/{y}{r}.png",
      "https://basemaps.cartocdn.com/light_all/{z}/{x}/{y}{r}.png",
      "https://cartodb-basemaps-{s}.global.ssl.fastly.net/light_all/{z}/{x}/{y}{r}.png",
      "https://{s}.basemaps.cartocdn.com/light_nolabels/{z}/{x}/{y}{r}.png",
      "https://basemaps.cartocdn.com/light_nolabels/{z}/{x}/{y}{r}.png",
      "https://cartodb-basemaps-{s}.global.ssl.fastly.net/light_nolabels/{z}/{x}/{y}{r}.png",
      "https://{s}.basemaps.cartocdn.com/rastertiles/voyager/{z}/{x}/{y}{r}.png",
      "https://basemaps.cartocdn.com/rastertiles/voyager/{z}/{x}/{y}{r}.png",
      "https://{s}.basemaps.cartocdn.com/rastertiles/voyager_nolabels/{z}/{x}/{y}{r}.png",
      "https://basemaps.cartocdn.com/rastertiles/voyager_nolabels/{z}/{x}/{y}{r}.png",
      "https://{s}.basemaps.cartocdn.com/rastertiles/voyager_labels_under/{z}/{x}/{y}{r}.png",
      "https://basemaps.cartocdn.com/rastertiles/voyager_labels_under/{z}/{x}/{y}{r}.png"
    ],
    "lineWidthStops": { "1": 1.0, "3": 1.0, "4": 2.0, "5": 2.0, "6": 2.5, "7": 3.0, "8": 3.0, "10": 4.0, "11": 4.0, "12": 4.0 },
    "lineStyles": [
      { "color": "rgb(235, 214, 214)", "layerSuffix": "ne", "endZoom": 4, "lineExtensionFactor": 0.1, "delWidthFactor": 2.5 },
      { "color": "rgb(235, 214, 214)", "layerSuffix": "ne-disp", "endZoom": 4, "delWidthFactor": 0 },
      { "color": "rgb(235, 214, 214)", "layerSuffix": "osm", "alpha": 0.1, "startZoom": 6, "lineWidthStops": { "6": 20, "8": 19, "10": 18, "12": 17 }, "lineExtensionFactor": 0.1 },
      { "color": "rgb(235, 214, 214)", "layerSuffix": "osm", "startZoom": 5, "lineExtensionFactor": 0.1 },
      { "color": "rgb(235, 214, 214)", "layerSuffix": "osm-disp", "startZoom": 5,  "delWidthFactor": 0 },
      { "color": "rgb(235, 214, 214)", "layerSuffix": "osm-internal", "startZoom": 5, "widthFraction": 0.5, "dashArray": [4, 4], "delWidthFactor": 2.0 },
      { "color": "rgb(235, 214, 214)", "layerSuffix": "ne-internal", "startZoom": 4, "endZoom": 4, "widthFraction": 0.5, "dashArray": [4, 4], "delWidthFactor": 2.5 }
    ]
  },
  {
    "id": "open-topo",
    "tileUrlTemplates": [
      "https://{s}.tile.opentopomap.org/{z}/{x}/{y}.png",
      "https://tile.opentopomap.org/{z}/{x}/{y}.png",
      "https://{s}.tile.top-o-map.de/{z}/{x}/{y}.png",
      "https://tile.top-o-map.de/{z}/{x}/{y}.png"
    ],
    "lineWidthStops": { "4": 0.75, "5": 1.0, "6": 1.25, "7": 1.5, "8": 1.75, "9": 1.25, "10": 1.25, "13": 1.5 },
    "lineStyles": [
      { "color": "rgb(83, 83, 83)", "layerSuffix": "ne", "startZoom": 4, "endZoom": 6 },
      { "color": "rgb(173, 173, 173)", "layerSuffix": "osm", "startZoom": 7, "endZoom": 8, "alpha": 0.5, "widthFraction": 4 },
      { "color": "rgb(83, 83, 83)", "layerSuffix": "osm", "startZoom": 7, "endZoom": 8 },
      { "color": "rgb(83, 83, 83)", "layerSuffix": "osm-internal", "widthFraction": 0.75, "startZoom": 7, "endZoom": 8 },
      { "color": "rgb(199, 158, 204)", "layerSuffix": "osm", "startZoom": 9, "widthFraction": 7, "alpha": 0.6, "lineExtensionFactor": 0.2 },
      { "color": "rgb(175, 41, 203)", "layerSuffix": "osm", "startZoom": 9, "lineExtensionFactor": 0.2 },
      { "color": "rgb(199, 158, 204)", "layerSuffix": "osm-internal", "startZoom": 9, "widthFraction": 2.25, "alpha": 0.6, "lineExtensionFactor": 0.2 },
      { "color": "rgb(175, 41, 203)", "layerSuffix": "osm-internal", "startZoom": 9, "widthFactor": 0.75, "lineExtensionFactor": 0.2 }
    ]
  },
  {
    "id": "osm-carto",
    "tileUrlTemplates": [
      "https://tile.openstreetmap.org/{z}/{x}/{y}.png",
      "https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
    ],
    "lineWidthStops": { "3": 0.7, "4": 1.0, "10": 3.75 },
    "lineStyles": [
      { "color": "rgb(200, 180, 200)", "layerSuffix": "osm", "startZoom": 4, "delWidthFactor": 1.5 },
      { "color": "rgb(160, 120, 160)", "layerSuffix": "osm", "startZoom": 4, "widthFraction": 0.333, "dashArray": [30, 2, 8, 2], "delWidthFactor": 0 },
      { "color": "rgb(200, 180, 200)", "layerSuffix": "osm-internal", "startZoom": 4, "widthFraction": 0.45 },
      { "color": "rgb(160, 120, 160)", "layerSuffix": "osm-internal", "startZoom": 4, "widthFraction": 0.15, "dashArray": [10, 4, 2] }
    ]
  },
  {
    "id": "osm-hot",
    "tileUrlTemplates": [
      "https://{s}.tile.openstreetmap.fr/hot/{z}/{x}/{y}.png",
      "https://tile.openstreetmap.fr/hot/{z}/{x}/{y}.png"
    ],
    "lineWidthStops": { "2": 3.0, "3": 3.0, "7": 3.0, "8": 3.5, "9": 3.5 },
    "lineStyles": [
      { "color": "rgb(149, 175, 180)", "layerSuffix": "osm", "lineExtensionFactor": 0.25, "startZoom": 2 },
      { "color": "rgb(89, 117, 123)", "layerSuffix": "osm", "widthFraction": 0.33, "lineExtensionFactor": 0.25, "startZoom": 2 },
      { "color": "rgb(172, 163, 163)", "layerSuffix": "osm-internal", "widthFraction": 0.33, "startZoom": 4, "dashArray": [7, 7] }
    ]
  }
]
